'use client'

import React from 'react'
import Page404 from '~/components/error/404'
const NotFound = () => {
    return <Page404 />
}

export default NotFound